<template>
  <div class="hisbox" v-if='allpower'>
    <His ref='His' :clear='is_clear' :info="HisInfo" @resh='getCommList(true)'></His>
    <!-- 新增沟通记录 -->
    <div class="htit" style="border:0 none;">
      <div class="h2">案件沟通记录</div>
    </div>
    <div class="cselect">
      <a-radio-group button-style="solid" v-model='comType' @change="getCommList()">
        <a-radio-button style="font-size: 15px;border-radius: 4px;" :value="1"
          v-if='$common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? "case:communication:pjbefore:index" : "cancel.cause.communication.view")'>{{
            '裁决前沟通' }}（{{ comment.totals.talkCount }}）</a-radio-button>
        <a-radio-button style="font-size: 15px;margin: 0 10px;border-radius: 4px;" :value="2"
          v-if='$common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? "case:communication:zxbefore:index" : "cancel.cause.communication.view")'>执行前沟通（{{
            comment.totals.talkAfterJudCount }}）</a-radio-button>
        <a-radio-button style="font-size: 15px;border-radius: 4px;" :value="3"
          v-if='$common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? "case:communication:zxafter:index" : "cancel.cause.communication.view")'>执行后沟通（{{
            comment.totals.talkExecCount }}）</a-radio-button>
      </a-radio-group>
      <div class="rt">
        <a-button icon="plus" @click='HisInfo = {}; visibleShow("His")'
          v-if='$common.AccAUTH(accuser_id, power.add) && is_clear != 1 && $store.state.cause.invaild != 1'
          style="margin:0 0.75rem">添加</a-button>
        <a-button icon='upload' @click='download' v-if="$common.AccAUTH(accuser_id, power.export)">导出</a-button>
      </div>
    </div>
    <div class="ntable table" style="padding: 0 24px;"
      v-if='comList.length > 0 && $common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? power.see : "cancel.cause.communication.view")'>
      <table cellpadding="0" cellspacing="0" class="operation-table">
        <thead>
          <td width='40'>序号</td>
          <td width='140'>时间</td>
          <td width='70'>沟通方式</td>
          <td width='100'>联系方式</td>
          <td width='80'>我方人员</td>
          <td width='80'>对方人员</td>
          <td width='490'>沟通内容</td>
          <td width='112' class="operation-col">操作</td>
        </thead>
        <tbody>
          <tr v-for='(j, ind) in comList' :key='j.id'>
            <td>{{ ind + 1 }}</td>
            <td style="white-space: nowrap;">{{ j.create_time }}</td>
            <td>{{ j.type | rtype }}</td>
            <td>
              <Normap :tit='j.type_remark'></Normap>
            </td>
            <td>
              <Normap :tit='j.uname'></Normap>
            </td>
            <td>
              <Normap :tit='j.adversary'></Normap>
            </td>
            <td>
              <Tooltip :tit='j.content' v-if='j.content'></Tooltip>
            </td>
            <td class="operation-col">
              <div class="operation-btn-group">
                <a href='javascript:void(0);' @click='liteHis(j, true)'
                  v-if='$common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? power.see : "cancel.cause.communication.view")'>查看</a>
                <a href='javascript:void(0);'
                  v-if='$common.AccAUTH(accuser_id, $store.state.cause.invaild != 1 ? power.edit : "cancel.cause.communication.edit")'
                  @click='liteHis(j, false);'><span class="line"></span>修改</a>
                <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='delcomment(j.id)'>
                  <a href="javascript:void(0);" style="color:#f00;"
                    v-if='$common.AccAUTH(accuser_id, power.del) && is_clear != 1 && $store.state.cause.invaild != 1'>
                    <span class="line"></span>删除</a>
                </a-popconfirm>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pages" v-if='comment.total > 5'>
        <a-pagination v-model="comment.page" show-quick-jumper :total="comment.total" show-less-items :pageSize='5'
          @change='(e) => { comment.page = e }' />
      </div>
    </div>
  </div>
</template>
<script>
import His from './nHis.vue'
import { commentDel, commonList, groupCount } from '@/server/debtor'
import { Tacitly } from '@/assets/js/Tacitly'
export default {
  name: 'HisList',
  props: {
    accuser_id: Number,
    is_clear: Number,
    id: Number
  },
  components: { His },
  data() {
    return {
      comType: 1,
      comment: {
        page: 1,
        limit: 5,
        total: 0,
        totals: {}
      },
      commentList: [],
      HisInfo: {}
    }
  },
  filters: {
    rtype(val) {
      if (val) {
        const typelist = [
          { name: "未选择", value: 0 },
          { name: "现场", value: 1 },
          { name: "电话", value: 2 },
          { name: "短信", value: 3 },
          { name: "微信", value: 4 }
        ]
        return typelist[val].name
      }
      else {
        return '未选择'
      }
    },
  },
  mounted() {
    this.getCommList(true)
  },
  computed: {
    allpower() {
      const bool = (this.$common.AccAUTH(this.accuser_id, "case:communication:pjbefore:index") || this.$common.AccAUTH(this.accuser_id, "case:communication:zxbefore:index") || this.$common.AccAUTH(this.accuser_id, "case:communication:zxafter:index"))


      return this.$store.state.cause.invaild != 1 ? bool : this.$common.AccAUTH(this.accuser_id, "cancel.cause.communication.view")
    },
    power() {
      const power = {
        1: {     //裁决前沟通记录
          see: 'case:communication:pjbefore:index',
          add: 'case:communication:pjbefore:add',
          edit: 'case:communication:pjbefore:edit',
          del: 'case:communication:pjbefore:del',
          export: 'case:communication:pjbefore:export'
        },
        2: {   //执行前沟通记录
          see: 'case:communication:zxbefore:index',
          add: 'case:communication:zxbefore:add',
          edit: 'case:communication:zxbefore:edit',
          del: 'case:communication:zxbefore:del',
          export: 'case:communication:zxbefore:export'
        },
        3: { //执行后沟通记录
          see: 'case:communication:zxafter:index',
          add: 'case:communication:zxafter:add',
          edit: 'case:communication:zxafter:edit',
          del: 'case:communication:zxafter:del',
          export: 'case:communication:zxafter:export'
        }
      }
      return power[this.comType]
    },
    comList() {
      let slist = JSON.parse(JSON.stringify(this.commentList))
      if (this.comment.page == 1) {
        return slist.filter((ele, index) => { return index < 5 })
      } else {
        return slist.filter((ele, index) => { return index >= (this.comment.page - 1) * 5 && index < this.comment.page * 5 })
      }
    },
  },
  methods: {
    download() {
      if (this.comList.length == 0) return this.$message.error({ content: '当前暂无记录可导出' });
      let http = Tacitly.Base_Port
      this.$modal.confirm({
        content: '确认导出这个文件？',
        onOk: () => {
          window.open(http + 'cause/comments/export?cause_id=' + this.$store.state.cause.id + '&connect_type=' + this.comType)
        }
      });
    },
    delcomment(id) {
      commentDel({ comment_id: id }).then(e => {
        this.$message.success({ content: '已提交审核', key: 'updatable' });
        setTimeout(e => {
          window.history.go(0)
        }, 1000)
      })
    },
    getCommList(bool) {
      // console.log(this.$store.state.cause);

      const id = this.$store.state.cause.id
      this.comment.page = 1;
      if (bool) {
        groupCount({ cause_id: id }).then(e => {
          this.comment.totals = e
        })
      }
      // commonList({ cause_id: id ,limit:1}, 1).then(e => {
      //   this.comment.total1 = e.list.length
      // })
      // commonList({ cause_id: id ,limit:1}, 2).then(e => {
      //   this.comment.total2 = e.list.length
      // })
      // commonList({ cause_id: id ,limit:1}, 3).then(e => {
      //   this.comment.total3 = e.list.length
      // })
      commonList({ cause_id: id, limit: 1 }, this.comType).then(e => {
        this.commentList = e.list
        this.comment.total = e.list.length * 1
      })
    },
    visibleShow() {
      //this.$store.dispatch("openkey", { key: name, by: true })
      this.$refs.His.visible = true
    },
    liteHis(j, bool) {
      let k = Object.assign({ see: bool }, j)
      this.HisInfo = k
      this.visibleShow()
    },

  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-radio-button-wrapper {
  border: 1px solid #d9d9d9 !important;
  /* 恢复默认边框 */
  border-radius: 4px !important;
  /* 统一圆角，和你行内样式一致 */
}

::v-deep .ant-radio-button-wrapper:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

::v-deep .ant-radio-button-wrapper:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* 彻底移除中间分割伪线 */
::v-deep .ant-radio-button-wrapper:not(:first-child)::before {
  display: none;
}

/* 操作列整体右对齐 */
.operation-table .operation-col {
  text-align: left;
  /* 单元格内容右对齐 */
  padding-right: 10px;
  /* 可选：加右侧内边距，避免贴边 */
}

/* 操作按钮容器：确保不换行，且元素紧凑排列 */
.operation-btn-group {
  display: flex;
  /* 弹性布局，让按钮横向排列 */
  flex-wrap: nowrap;
  /* 强制不换行（核心） */
  justify-content: flex-start;
  /* 容器内元素右对齐，配合单元格的text-align */
  align-items: center;
  /* 垂直居中 */
  white-space: nowrap;
  /* 兜底：防止文本换行 */
}

/* 可选：调整按钮之间的分隔线和间距，优化显示 */
.operation-btn-group a {
  margin: 0 4px;
  /* 按钮之间加间距 */
  white-space: nowrap;
  /* 单个按钮文本不换行 */
}

.operation-btn-group .line {
  /* 分隔线样式优化，避免换行影响 */
  display: inline-block;
  width: 1px;
  height: 12px;
  background: #ccc;
  margin: 0 7px 0 0;
  vertical-align: middle;
}

.cselect {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px 20px 24px;
}
</style>